import { render } from "./FileDropzoneTypeComponent.vue?vue&type=template&id=f957b052&scoped=true"
import script from "./FileDropzoneTypeComponent.vue?vue&type=script&lang=js"
export * from "./FileDropzoneTypeComponent.vue?vue&type=script&lang=js"

import "./FileDropzoneTypeComponent.vue?vue&type=style&index=0&id=f957b052&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f957b052"]])

export default __exports__